const config = {
	context: {
		global: {
			locale: 'de-CH',
			online: true
		},
		i18n: {
			seniors: 'Seniors',
			adults: 'Adults',
			highSeason: 'High Season',
			youth: 'Youth',
			pupils: 'Pupils',
			children: 'Children',
			fromAge: 'from age {age}',
			seniorsMinAge: '62',
			ageRange: '{minAge}-{maxAge} years',
			upToGrade: 'up to {grade} grade',
			adultsMinAge: '16', // Used when no youth age group is available (all but ski passes)
			adultsMinAgeWithYouth: '20', // Used when youth age group is available (ski passes)
			youthMinAge: '16',
			youthMaxAge: '19',
			pupilsMaxGrade: '9th',
			childrenMinAge: '6',
			childrenMaxAge: '15',
			discountCriteria: '{halfFareCard}, {generalAbonnementAbbrev}, {swissTravelPass}',
			discountCriteriaChild: '{juniorCard}, {kidCoTravelerCard}, {swissFamilyCard}',
			juniorCard: 'Junior Card',
			kidCoTravelerCard: 'Kid Co-Traveler Card',
			swissFamilyCard: 'Swiss Family Card',
			halfFareCard: 'Half fare card',
			generalAbonnementAbbrev: 'GA',
			swissTravelPass: 'Swiss Travel Pass',
			individuals: 'Individuals',
			groups: 'Groups',
			xPersonsPlus: '{persons} persons+',
			minGroupSize: '10',
			activity: 'Activity',
			activities: 'Activities',
			mobile: 'Mobile',
			landline: 'Landline',
			fax: 'Fax',
			addCustomSlide: 'Add custom slide',
			selectAll: 'Select all',
			deselectAll: 'Deselect all',
			language: 'Language',
			setup: 'Setup',
			systemOfUnits: 'Units',
			metrical: 'Metrical',
			imperial: 'Imperial',
			clientLogo: 'Client logo',
			chooseClientLogo: 'Choose client logo',
			chooseImageOrVideo: 'Choose Image',
			travelGuideBenefits: 'Travel guide benefits',
			show: 'Show',
			dontShow: 'Don’t show',
			welcome: 'Welcome',
			intro: 'Intro',
			headline: 'Headline',
			copy: 'Copy',
			background: 'Background',
			image: 'Image',
			video: 'Video',
			partnerLogos: 'Partner logos',
			yes: 'Yes',
			no: 'No',
			createNew: 'Create new',
			view: 'View',
			edit: 'Edit',
			save: 'Save',
			present: 'Present',
			unarchive: 'Unarchive',
			back: 'Back',
			next: 'Next',
			continue: 'Continue',
			thankYou: 'Thank you',
			addAnotherContactPerson: 'Add another Sales Manag/Rep',
			chooseAPerson: 'Choose a person',
			buildYourCustomSlide: 'Build your custom slide',
			badgeText: 'Badge text',
			close: 'Schliessen',
			myPresentations: 'My Presentations',
			latestPresentations: 'Latest Presentations',
			salesManual: 'Sales Tool',
			by: 'by',
			endPresentation: 'End Presentation',
			logOut: 'Log out',
			reportIssue: 'Report Issue',
			changelog: 'Changelog',
			version: 'Version',
			branch: 'Branch',
			date: 'Date',
			remove: 'Remove',
			day: 'Day',
			days: 'Days',
			connectingTicket: 'Connecting Ticket',
			bookingCode: 'Booking Code',
			perPerson: 'per Person',
			b2c: 'B2C',
			b2b: 'B2B',
			elevation: 'Elevation',
			operatingTime: 'Operating Time',
			price: 'Price',
			elevationAboveSeaLevel: '{elevation} {unitAboveSeaLevel}',
			elevationRangeAboveSeaLevel: '{elevationMin} – {elevationMax} {unitAboveSeaLevel}',
			metersAboveSeaLevel: 'm a.s.l',
			feetAboveSeaLevel: 'f a.s.l.',
			distanceWithUnit: '{distance} {distanceUnit}',
			distanceUnitKilometers: 'km',
			distanceUnitMiles: 'mi',
			durationWithUnit: '{duration} {durationUnit}',
			durationUnitMinutes: 'min',
			none: 'None',
			start: 'Start',
			presentationMode: 'Presentation mode',
			static: 'Static',
			dynamic: 'Dynamic',
			youAreOnline: 'You are online.',
			youAreOffline: 'You are offline.',
			update: 'update',
			upgrade: 'upgrade',
			upgradeAllOutdated: 'upgrade all outdated',
			duplicate: 'duplicate',
			exportPowerPointPresentation: 'PPT export',
			exportPowerPointPresentationInfo:
				'Please keep this window and your browser’s tab in foreground. Otherwise, the export speed will decrease.',
			exportPowerPointPresentationError: 'Export failed.',
			delete: 'delete',
			areYouSure: 'Are you sure?',
			toggleFullscreen: 'Toggle fullscreen',
			reload: 'Reload',
			reset: 'Reset',
			playVideo: 'Video abspielen',
			stopVideo: 'Video stoppen',
			warning: 'Warning',
			resetWarning:
				'Warning: this will reset the offline cache. No Presentations will be deleted, but they will remain unpresentable until the offline cache has recovered.',
			errorsInPresentationWarning:
				'Warning: at least one slide is corrupted (marked gray in the light table view). Please report this issue and include a link to this presentation.',
			secondClass: '2nd class',
			newPresentationMasterAvailable: 'New presentation master available.',
			upgradeInstructions: "Click{icon}to learn what's new and install the latest version for a presentation.",
			expiredInstructions: '{icon}- includes outdated content.',
			presentationMasterChangesSinceLastUpgrade: 'Presentation master changes since last upgrade',
			masterInPresentationEffective: 'Master in presentation effective',
			presentationWillNotBeUsableDuringUpdate: 'Presentation will not be usable during update.',
			noInformationOnMasterUpdatesAvailable: 'No information on master updates available',
			presentModeDisabledWarning: 'Present mode is disabled as your browser does not support offline caching.',
			presentModeDisabledWarningAdditionalInfo:
				'Please only use browsers explicitly approved for this application and do not enable private browsing.',
			introVideo: 'Intro video',
			noIntroVideo: 'No intro video',
			highlights: 'Highlights',
			offers: 'Offers',
			cooperations: 'Cooperations',
			homePage: 'Home',
			startingDecember2020: 'Starting December 2020',
			scrollDownToExplore: 'Scroll down to explore',
			directlyToHighlights: 'Directly to the Highlights',
			specialInfo: 'Special Info',
			shareViewFootnote: 'All prices in CHF including 7.7% VAT.',
			trainRoutes: 'Train routes',
			skiRegions: 'Ski regions',
			location: 'Location',
			gettingThere: 'Getting there',
			cookieInfo:
				'<p>Wir verwenden Cookies zur Unterstützung der Benutzerfreundlichkeit. Mit der Nutzung dieser Webseite erklären Sie sich damit einverstanden, dass Cookies verwendet werden. Weitere Informationen finden Sie in unseren <a href="https://www.jungfrau.ch/de-ch/anb/#c7794" target="_blank">ANB</a>.</p>',
			cookieInfoConfirmButtonLabel: 'Hinweis gelesen',
			pisteLength: 'Piste length',
			lifts: 'Lifts',
			sledTrackLength: 'Sled tracks',
			winterHikeLength: 'Winter hikes',
			fallbackPresentationId: 'eYA9cW5l7nQfd4Z4xCCWY',
			openingTimeFullYearTrains: '365 days a year (train)',
			openingTimeFullYearVenues: '365 days a year (venue)',
			maintenancePrefix: 'Maintenance'
		}
	}
};

module.exports = config;
